import React from 'react'
import { connect } from 'react-redux'

import Form from './form'
import TwoFactor from './two_factor'

const mapStateToProps = state => ({
  stage: state.users.sessions.index.stage
})

const mapDispatchToProps = dispatch => ({})

export default connect(mapStateToProps, mapDispatchToProps)(
  ({ stage }) => (stage === 0 ? <Form /> : <TwoFactor />)
)



// WEBPACK FOOTER //
// ./src/containers/pages/users/sign_in/index.js